import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=fa55a674&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=js&"
export * from "./configuration.vue?vue&type=script&lang=js&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=fa55a674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55a674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa55a674')) {
      api.createRecord('fa55a674', component.options)
    } else {
      api.reload('fa55a674', component.options)
    }
    module.hot.accept("./configuration.vue?vue&type=template&id=fa55a674&scoped=true&", function () {
      api.rerender('fa55a674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/configuration.vue"
export default component.exports